import React, { useMemo, useState } from 'react';
import './b2bProscpect.css';
import axios from 'axios';
import { useRecoilState } from 'recoil';
import { alertState } from '../../../../utils/recoil/snackbar';
import { withLocale } from '../../../../utils/hocs/withLocale';
import { Form } from '../../../UI/Forms/Form/form';
import { Link } from '../../../UI/Elements/Link';
import NoozApi from '../../../../services/NoozApi';
import {
  formatContentfulComponentProps,
  returnLocalisedPath,
} from 'utils/globals';
import { TabListItem } from 'components/UI/Navigation/Tabs/Tab';

import { navigate } from 'gatsby';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import 'utils/yup/methods';

const ProspectTabs = ({ links, locale }) => (
  <div className='flex border-t h-16 w-full overflow-x-scroll no-scrollbar justify-center'>
    {links.items.map((item, index) => {
      const {
        label,
        color,
        slug: { url },
      } = item;

      const isActive =
        typeof window === 'undefined'
          ? false
          : window.location.pathname.includes(url);

      return (
        <div
          role='button'
          tabIndex={index}
          onKeyDown={() => navigate(returnLocalisedPath(locale, url))}
          className='w-1/2 md:w-1/3 min-w-1/3 lg:min-w-min h-full flex justify-center items-center'
          onClick={() => navigate(returnLocalisedPath(locale, url))}>
          <TabListItem
            borderPlacement='top'
            label={{
              ...label,
              size: 'lg',
              weight: isActive ? 'medium' : 'light',
            }}
            color={color}
            selected={isActive}
          />
        </div>
      );
    })}
  </div>
);

const ProspectContent = ({
  isLoading,
  handleOnSubmit,
  inputs,
  body,
  submitButton,
  errorLabels,
}) => {
  const resolver = useMemo(() => {
    const schema = {};

    inputs.forEach((input) => {
      if (input.required) {
        switch (input.name) {
          case 'phone':
            schema[input.name] = yup.string().phoneValid();
            break;
          case 'typeOfStores':
            schema[input.name] = yup.array().min(1);
            break;
          default:
            break;
        }
      }
    });

    return yupResolver(yup.object(schema));
  }, [inputs]);

  return (
    <div className={'flex justify-center mt-6'}>
      <div className='w-full prospect'>
        <Form
          errorLabels={errorLabels}
          resolver={resolver}
          isLoading={isLoading}
          onSubmit={handleOnSubmit}
          inputs={inputs}
          body={body}
          submitButton={submitButton}
        />
      </div>
    </div>
  );
};

export const B2bProspectForm = withLocale(({ form, links, locale }) => {
  const { label, successLabels, errorLabels, inputs, body, submitButton } =
    form;
  const [alert, setAlert] = useRecoilState(alertState);
  const [isLoading, setIsLoading] = useState(false);

  const handleOnSubmit = (data) => {
    setIsLoading(true);
    NoozApi({
      method: 'POST',
      url: '/prospect',
      data: {
        body: data,
        prospect: label?.text,
      },
    })
      .then((response) => {
        setIsLoading(false);
        // Valid response returns contact's Id : an integer
        const validResponse = Number.isInteger(response.data?.response);
        if (validResponse) {
          setAlert({
            ...alert,
            show: true,
            type: 'success',
            title: successLabels[0]?.text,
          });
        } else {
          setAlert({
            ...alert,
            show: true,
            type: 'error',
            title: errorLabels[0]?.text,
          });
        }
      })
      .catch(({ response }) => {
        setIsLoading(false);
        setAlert({
          ...alert,
          show: true,
          type: 'error',
          title: `${errorLabels[0]?.text} : ${response?.data}`,
        });
      });
  };

  return (
    <div className='w-full pb-8'>
      <ProspectTabs
        links={links}
        locale={locale?.[0]}
      />
      <ProspectContent
        errorLabels={errorLabels}
        isLoading={isLoading}
        handleOnSubmit={handleOnSubmit}
        inputs={inputs}
        body={body}
        submitButton={submitButton}
      />
    </div>
  );
});
